import { render, staticRenderFns } from "./PollActivityRow.vue?vue&type=template&id=64d128d6&"
import script from "./PollActivityRow.vue?vue&type=script&lang=js&"
export * from "./PollActivityRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports